import Model from './Model';

export default class AffiliatePayment extends Model {
  request(config) {
    // A lost response is uncertain completion; the UI must never retry a payment automatically.
    return super.request({ ...config, timeout: 45000 });
  }
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'affiliate-payments';
  }
}
